import Box from "ds/components/Box";
import Card from "ds/components/Card";
import Typography from "ds/components/Typography";
import ExportTracesButton from "components/Run/elements/ExportTraces/Button";

import { PHASE_EXECUTION_TIME_GRID_TEMPLATE } from "./constants";
import PhaseExecutionTimeRow from "./Row";
import styles from "./styles.module.css";
import { PhaseExecutionTimeBar } from "./types";

type PhaseExecutionTimeProps = {
  bars: PhaseExecutionTimeBar[];
};

const PhaseExecutionTime = ({ bars }: PhaseExecutionTimeProps) => {
  if (bars.length === 0) {
    return null;
  }

  return (
    <Card
      title="Phase execution time"
      headerSuffix={<ExportTracesButton size="small" />}
      contentGap="0"
      contentClassName={styles.content}
      fullbleed
    >
      <Box direction="column" className={styles.table}>
        <Box
          grid
          gridTemplate={PHASE_EXECUTION_TIME_GRID_TEMPLATE}
          gap="x-large"
          padding="0 x-large"
          className={styles.headerStrip}
        >
          <Box
            align="center"
            justify="between"
            padding="0 x-large 0 0"
            className={styles.phaseHeaderCell}
          >
            <Typography tag="span" variant="p-body4" color="secondary">
              Phase
            </Typography>
            <Typography tag="span" variant="p-body4" color="secondary">
              vs P95
            </Typography>
          </Box>
        </Box>

        {bars.map((bar) => (
          <PhaseExecutionTimeRow key={bar.state.runState} {...bar} />
        ))}
      </Box>
    </Card>
  );
};

export default PhaseExecutionTime;
